import { Provider } from 'react-redux';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { store } from './redux/store';
import { VehicleShop } from './views/VehicleShop';

const LayoutComponent = () => (
	<Provider store={store}>
		<VehicleShop />
	</Provider>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.VehicleShop)
	.build();

export default Layout;
